import { createContext } from "react";

export const BulletinsContext = createContext(null);

// Module-level callback registry for refresh functionality
// This allows modals (which are rendered outside the Bulletins component tree)
// to trigger a refresh of the bulletins table
let refreshCallback = null;

export const setBulletinsRefreshCallback = (callback) => {
  refreshCallback = callback;
};

export const getBulletinsRefreshCallback = () => {
  return refreshCallback;
};

export const refreshBulletins = () => {
  if (refreshCallback) {
    refreshCallback();
  }
};

